class GoogleMapIndividual {
	constructor() {
		this.container = document.querySelector(".google-map-individual");
		if (this.container) {
			resizeCallbacks.push(this);
			this.buildTheMap();
		}
	}

	buildTheMap() {
		const theMap = this.container.querySelector(".google-map");
		const markers = this.container.querySelectorAll(".google-map-markers .item");
		const customZoom = this.container.querySelector(".custom-zoom");

		if (theMap) {
			this.bounds = new google.maps.LatLngBounds();
			this.markersResults = [];

			this.map = new google.maps.Map(theMap, {
				center: {lat: 45.619722, lng: 4.6730292},
				zoom: 11,
				maxZoom: 18,
				disableDefaultUI: true,
				styles: googleMapStyle
			});

			markers.forEach(marker => {
				let lat = marker.dataset.lat;
				let lng = marker.dataset.lng;
				let icon = marker.dataset.icon;

				if (lat && lng) {
					marker = new google.maps.Marker({
						position: {
							lat: parseFloat(lat),
							lng: parseFloat(lng)
						},
						map: this.map,
						icon: this.chooseIcon(icon)
					});

					this.bounds.extend(marker.getPosition());
				}
			});

			this.map.fitBounds(this.bounds);
			if (customZoom) {
				this.customZoom(customZoom, this.map);
			}
		}
	}


	customZoom(controlDiv, map) {
		google.maps.event.addDomListener(zoomout, 'click', function () {
			var currentZoomLevel = map.getZoom();
			if (currentZoomLevel != 0) {
				map.setZoom(currentZoomLevel - 1);
			}
		});

		google.maps.event.addDomListener(zoomin, 'click', function () {
			var currentZoomLevel = map.getZoom();
			if (currentZoomLevel != 21) {
				map.setZoom(currentZoomLevel + 1);
			}
		});
	}

	chooseIcon(icon) {
		if (icon === "bus") {
			return {
				url: mcubeArgs.themeLink + "/images/pointer-bus.png",
				scaledSize: new google.maps.Size(80, 40)
			};
		} else {
			return {
				url: mcubeArgs.themeLink + "/images/pointer-flower.png",
				scaledSize: new google.maps.Size(36, 45)
			};
		}
	}

	resize() {
		this.map.fitBounds(this.bounds);
	}
}